import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-departaments',
  templateUrl: './departaments.component.html',
  styleUrls: ['./departaments.component.scss']
})
export class DepartamentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
